import React, {createContext, useContext, useCallback} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const AuditOperationsApiContext = createContext(null);

export function AuditOperationsApiProvider({children}) {

  const {get} = useApiService(CONFIG.SERVER_ORGANIZATION);

  const getAuditOperations = useCallback(async (skip, limit, start_date, end_date, type=null) => {
    let endpoint = `/v1/audit/operation?start_date=${start_date}&end_date=${end_date}`;
    if (skip !== null && limit !== null) {
      endpoint += `&skip=${skip || 0}&limit=${limit || 10}`;
    }
    try {
      let endpoint = `/v1/audit/operation?skip=${skip}&limit=${limit}&start_date=${start_date}&end_date=${end_date}`;
      if (type) {
        const types = Array.isArray(type) ? type : [type];
        endpoint += types.map(t => `&type=${t}`).join("");
      }
      const response = await get(endpoint);
      return response.data;
    } catch (error) {
      console.error("Error fetching audit operation:", error);
      throw error;
    }
  }, [get]);

  const getAuditOperationById = useCallback(async (auditId) => {
    try {
      const response = await get(`/v1/audit/operation/${auditId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching audit operation by ID:", error);
      throw error;
    }
  }, [get]);

  const getAuditOperationTypes = useCallback(async () => {
    try {
      const response = await get(`/v1/audit/operation/types`);
      return response.data;
    } catch (error) {
      console.error("Error fetching audit operation types:", error);
    }
  }, [get]);


const exportAuditOperations = useCallback(async (start_date, end_date, type = null) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.set("start_date", start_date);
    if (end_date)   params.set("end_date", end_date);
    if (type && type.length) (Array.isArray(type) ? type : [type]).forEach(t => params.append("type", t));

    const endpoint = `/v1/audit/operation/export?${params.toString()}`;

    const response = await get(endpoint, { responseType: "blob" });

    const blob =
      response?.data instanceof Blob
        ? response.data
        : new Blob([JSON.stringify(response?.data ?? [])], { type: "application/json" });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "audit_operations.json";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting audit operations:", error);
    throw error;
  }
}, [get]);




  return (
    <AuditOperationsApiContext.Provider value={{
      getAuditOperations,
      getAuditOperationById,
      getAuditOperationTypes,
      exportAuditOperations
    }}>
      {children}
    </AuditOperationsApiContext.Provider>
  );
}

export function useAuditOperationsApi() {
  const context = useContext(AuditOperationsApiContext);
  if (!context) {
    throw new Error("useAuditOperationsApi must be used within a AuditOperationsApiProvider");
  }
  return context;
}